import { render, staticRenderFns } from "./PaymentProviderRedirect.vue?vue&type=template&id=a18dc240&scoped=true&"
import script from "./PaymentProviderRedirect.vue?vue&type=script&lang=ts&"
export * from "./PaymentProviderRedirect.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentProviderRedirect.vue?vue&type=style&index=0&id=a18dc240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18dc240",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
